<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <v-form v-if="!loading" v-model="valid">
          <v-row>
            <p class="subtitle-1 font-weight-bold mb-2">Upload Attachments</p>
          </v-row>
          <v-row>
            <v-file-input
              v-model="attachments"
              accept="image/*, application/pdf"
              label="Click here to upload attachments"
              prepend-icon=""
              chips
              small-chips
              multiple
              outlined
              dense
              :rules="rules"
              class="mt-4"
            >
              <template v-slot:prepend-inner>
                <v-icon small class="mt-1">mdi-paperclip</v-icon>
              </template>
            </v-file-input>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              depressed
              text
              :disabled="!valid"
              @click="upload"
            >
              UPLOAD
            </v-btn>
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >Cancel</v-btn
            >
          </v-row>
        </v-form>
        <v-skeleton-loader v-else type="article"></v-skeleton-loader>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    valid: false,
    dialog: false,
    attachments: null,
    options: {
      color: 'primary',
      width: 500,
      zIndex: 200
    },
    bedDetails: '',
    rules: [(value) => !!value || 'Please select a file']
  }),
  computed: {
    selectedBed() {
      return this.$store.getters['units/getSelectedBed']
    }
  },
  methods: {
    open(params) {
      this.bedDetails = params
      this.dialog = true
    },
    async upload() {
      this.loading = true
      try {
        const response = await this.$store.dispatch(
          'units/uploadAttachmentsAction',
          {
            leaseId: this.bedDetails.leaseId,
            attachments: this.attachments
          }
        )
        if (response.status === 200) {
          this.$router.go()
        } else {
          this.loading = false
        }
      } catch (err) {
        this.loading = false
        let message = ''
        switch (err.status) {
          case 413:
            message = 'File size too large. Please limit your file to 2MB.'
            break
          case 415:
            message = 'Please select an image or PDF file.'
            break
          default:
            message = 'There was an error processing your request.'
        }
        this.$root.$confirm({
          title: 'Error Uploading File',
          message: message,
          options: {
            color: 'warning'
          },
          reconfirmOnly: true,
          confirmText: 'OK'
        })
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
